import { render } from "./AppHeaderLogin.vue?vue&type=template&id=4c447264&scoped=true"
import script from "./AppHeaderLogin.vue?vue&type=script&lang=js"
export * from "./AppHeaderLogin.vue?vue&type=script&lang=js"

import "./AppHeaderLogin.vue?vue&type=style&index=0&id=4c447264&scoped=true&lang=css"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c447264"]])

export default __exports__